<template>
  <div class="outmain heighthv pad_20 bor_rad5 ba_f">
    <div class="ba_f">
      <div class="shuju_title mar_b20">
        <div class="shuju_title_text">
          <span>骑士学院</span>
        </div>
      </div>
      <el-form :inline="true" :model="formInline">
        <el-form-item label="题库类型" class="mar_l20">
          <el-select v-model="formInline.typeId" style="width: 200px;" :placeholder="$t('common.pleaseSelect')" @change="getLearnList">
            <el-option label="全部" value></el-option>
            <el-option label="入职考试" value="1"></el-option>
            <el-option label="专项考试" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="题库标题" class="mar_l20">
          <el-input style="width: 200px;" v-model="formInline.title" :placeholder="$t('plugin.learnings.title')" @input="getLearnList"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="ba_f mar_t20 pad_20">
      <div class="t_l mar_b20">
        <el-button type="primary" size="medium" @click="handleEdit(false)">新增题库</el-button>
      </div>
      <el-table v-loading="listLoading" :element-loading-text="loadingText" :data="tableList" stripe style="width: 100%;" @selection-change="setSelectRows">
        <el-table-column prop="sort" label="排序" width="100"></el-table-column>
        <el-table-column prop="title" label="题库标题"></el-table-column>
        <el-table-column prop="storeName" label="题库类型">
          <template slot-scope="scope">
            <span>{{ scope.row.typeId == '1' ? '入职考试' : '专项考试' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="topicNum" label="题目数量"></el-table-column>
        <el-table-column :label="$t('plugin.learnings.participants')" min-width="100">
          <template slot-scope="scope">
            <div class="flex">
              <section class="debug-d debug-trip" style="background: #2a75ed;">�</section>
              <span>�</span>
              <span>{{ scope.row.totalNum }}</span>
            </div>
            <div class="flex mar_t20">
              <section class="debug-d debug-trip" style="background: #FF8000;">�</section>
              <span>�</span>
              <span>{{ scope.row.passNum }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="添加时间" align="center"></el-table-column>
        <el-table-column :label="$t('common.operation')" fixed="right" width="250" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="addSubject(scope.row.id)">查看题库</el-button>
            <el-button type="text" @click="handTestList(scope.row.id)">参与人数</el-button>
            <el-button type="text" @click="handleEdit(scope.row.id)">{{ $t('common.edit') }}</el-button>
            <el-button type="text" @click="deleteStore(scope.row.id)">{{ $t('common.delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next" :total="page.total" :page-size="page.size" :current-page.sync="formInline.page" @current-change="handleCurrentChange"></el-pagination>
    </div>
    <learnings-add-edit ref="LearningsAddEdit" v-if="LearningsAddEdit" @callbackclose="callbackclose"></learnings-add-edit>
    <learnings-test-list ref="testList" v-if="testList"></learnings-test-list>
  </div>
</template>
<script>
import { learningList } from '@/api/plugins.js';
import LearningsAddEdit from './components/learnings-add-edit.vue';
import LearningsTestList from './components/learnings-test-list.vue';
export default {
  components: {
    LearningsAddEdit,
    LearningsTestList
  },
  data() {
    return {
      listLoading: false,
      testList: false,
      
      LearningsAddEdit: false,
      tableList: [],
      formInline: {
        page: 1,
        typeId: '',
        title: ''
      },
      page: {
        total: 0,
        size: 10
      }
    };
  },
  created() {
    this.getLearnList();
  },
  computed: {

    loadingText() {

      return this.$t('common.loading');

    },

  },

  methods: {
    getLearnList() {
      learningList(this.formInline).then((res) => {
        if (res.code == 1) {
          this.tableList = res.data;
          this.page.total = res.count;
        }
      });
    },
    callbackclose() {
      this.LearningsAddEdit = false;
      this.getLearnList();
    },
    // 条件筛选筛�?
    onSearch() {},
    // 添加与编�?
    handleEdit(id) {
      this.LearningsAddEdit = true;
      this.$nextTick(() => {
        this.$refs.LearningsAddEdit.init(id);
      });
    },
    handTestList(id) {
      this.testList = true;
      this.$nextTick(() => {
        this.$refs.testList.init(id);
      });
    },
    // 多选回�?
    setSelectRows() {},
    // 分页回调
    handleCurrentChange() {},
    addSubject(id) {
      this.$router.push({
        name: 'LearningsAdd',
        query: {
          id: id
        }
      });
    }
  }
};
</script>
